import { TokenUtilPreviewMetadataGenerator } from "./TokenUtilPreviewMetadataGenerator";
import { TokenUtilPreviewReferenceInfoGenerator } from "./TokenUtilPreviewReferenceInfoGenerator";
import { TokenUtilPreviewSegmentGenerator } from "./TokenUtilPreviewSegmentGenerator";
import { TokenUtilPreviewStyleGenerator } from "./TokenUtilPreviewStyleGenerator";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Static generators
const tokenPreviewMetadataGenerator = new TokenUtilPreviewMetadataGenerator();
const tokenPreviewStyleGenerator = new TokenUtilPreviewStyleGenerator();
const tokenPreviewReferenceInfoGenerator = new TokenUtilPreviewReferenceInfoGenerator();
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Utility
export class TokenUtilPreviewGenerator {
    /** Generates segments required for rendering of the preview. Only usable with Supernova preview */
    static tokenPreviewSegments(token, allTokens) {
        return TokenUtilPreviewSegmentGenerator.resolvedSegmentsForToken(token, allTokens);
    }
    /** Generates metadata required for rendering of the preview. Only usable with Supernova preview */
    static tokenPreviewMetadata(token, allTokens) {
        return tokenPreviewMetadataGenerator.resolvedMetadataForToken(token, allTokens);
    }
    /** Generates style required for rendering of the preview. Only usable with Supernova preview */
    static tokenPreviewStyle(token, overridenStyles) {
        // @ts-expect-error TS(2322): Type 'TokenUtilPreviewResolvedStyle | undefined' i... Remove this comment to see the full error message
        return tokenPreviewStyleGenerator.resolvedStyleForToken(token, overridenStyles);
    }
    /** Generates adjusted preview type required for rendering of the preview. Only usable with Supernova preview */
    static tokenPreviewType(token) {
        return tokenPreviewMetadataGenerator.tokenTypeToPreviewType(token.tokenType);
    }
    /** Generates per-value description of passed token. Only usable with Supernova preview */
    static tokenReferenceInfoForSingleLayerToken(token, allTokens) {
        return tokenPreviewReferenceInfoGenerator.resolvedInfoForSingleLayerToken(token, allTokens);
    }
    /** Generates per-value description of passed token. Only usable with Supernova preview */
    static tokenReferenceInfoForMultiLayerToken(token, layerIndex, allTokens) {
        return tokenPreviewReferenceInfoGenerator.resolvedInfoForMultiLayerToken(token, layerIndex, allTokens);
    }
}
